// extracted by mini-css-extract-plugin
module.exports = {"row":"history_row__fgdrO","container":"history_container__EZ4Oz"};